// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".enduser-page {\n  top: 65px;\n  position: relative;\n  left: 0px;\n  right: 0px;\n}\n", "",{"version":3,"sources":["webpack://src/app/pages/EndUser/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ","sourcesContent":[".enduser-page {\n  top: 65px;\n  position: relative;\n  left: 0px;\n  right: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
